import styled from "@emotion/styled";

import { styleCss } from "components/layout/utils";

export const Container = styled.div`
  overflow: auto;
  height: 100%;
`;

export const Wrapper = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  padding: 30px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  text-align: left;
  line-height: 1.4;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };

  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    margin-top: 20px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 480px;
`;

export const Header = styled.h1`
  text-align: center;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 0.5em;
`;

export const Headline = styled.p`
  text-align: center;
`;

export const StepImage = styled.img`
  display: block;
  margin: 0 auto 20px;
  height: 90px;
  ${styleCss("fill")};
`;
